<template>
  <transition name="fade">
    <div class="wrap">
      <div class="side-line">
        <div
          class="title f-db"
        >
          <img
            src="@/assets/img/cmef-tx.png"
            class="empty-img s-circl"
          />
          <p>CMEF</p>
          <span class="link" @click="show=true;">Talk now</span>
        </div>
      </div>


      <iModal footer-hide	v-model="show" width="486" class-name="kefu-modal">
        <div class="kefu">
          <p class="kf-title">Talk now</p>
          <div class="img-box">
            <img src="@assets/img/kf-ewm.png" />
            <p class="img-box-p">扫码添加客服微信</p>
          </div>
          <div class="kf-btn" @click="show=false;">我知道了</div>
        </div>
      </iModal>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "activity-item",
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    exhibitionId() {
      return this.$store.state.exhibitionId;
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      getUser: "hall/getUser"
    }),
    supply() {
      if (!this.user) {
        this.$Message.warning("请登录后发布");
        return;
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.wrap {
  width: 300px;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  .title {
    min-height: 215px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 30px;
    background-color: #fff;
  }
  .title img {
    width: 96px;
    height: 96px;
    margin-top: 40px;
    // border: solid 1px #e6e6e6;
    // border-radius: 50%;
  }
  .title p {
    font-size: 18px;
    color: #222;
    margin-top: 20px;
    font-weight: 600;
  }
  .code {
    overflow: hidden;
    background-color: #fff;
  }
  .code img {
    margin: 10px auto !important;
  }
  .code p {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .qrcode2 {
    text-align: center;
    padding: 10px;
  }
  .info {
    background-color: #fff;
    padding: 20px;
    color: #333;
    text-align: left;
    p {
      margin-bottom: 10px;
    }
  }
  .btn-wrap {
    .btn {
      line-height: 35px;
      border-radius: 4px;
      border: solid 1px #fe781d;
    }
  }
}
.side-line {
  margin-bottom: 4px;
}
.link{
  display: inline-block;
  width: 220px;
	height: 36px;
	background-color: #fe781d;
	border-radius: 4px;
  font-size: 14px;
	line-height: 36px;
	color: #fff;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.kefu {
  margin-top: 20px;
  text-align: center;
  .kf-title {
    font-size: 20px;
    color: #333;
  }
  .img-box {
    width: 240px;
    height: 260px;
    border-radius: 2px;
    border: 1px solid #e6e6e6;
    margin: 0 auto;
    margin-top: 20px;
    &-p {
      line-height: 30px;
      color: #333;
      font-size: 16px;
    }
  }
  img {
    width: 205px;
    height: 205px;
    margin-top: 15px;
  }
  .kf-btn {
    width: 240px;
    height: 60px;
    background-color: #f8f8f8;
    border-radius: 5px;
    border: solid 1px #eeeeee;
    line-height: 60px;
    text-align: center;
    margin: 30px auto;
    cursor: pointer;
    font-size: 20px;
    color: #333;
  }
}
</style>